import { SwipeableDrawer } from '@mui/material'
import { Dispatch, PropsWithChildren, SetStateAction } from 'react'
import Stats from 'containers/search/Stats'
import { unifiedColors } from 'styles/colors'
import {
  EventsDrawerContent,
  EventsDrawerHeader,
  Puller,
  StatsContainer
} from './EventsDrawer.style'

interface EventsDrawerProps extends PropsWithChildren {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}

export const EventsDrawer = ({
  children,
  open,
  setOpen
}: EventsDrawerProps) => {
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen)
  }
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      swipeAreaWidth={56}
      disableSwipeToOpen={false}
      disablePortal
      ModalProps={{
        keepMounted: true
      }}
      sx={{
        '&.MuiDrawer-root > .MuiPaper-root': {
          overflow: 'visible',
          top: '122px'
        }
      }}
    >
      <EventsDrawerHeader>
        <Puller />
        <StatsContainer>
          <Stats />
        </StatsContainer>
      </EventsDrawerHeader>
      <EventsDrawerContent bgcolor={unifiedColors.surface.subdued}>
        {children}
      </EventsDrawerContent>
    </SwipeableDrawer>
  )
}
